import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../../../services/api';
import logo from '../../../images/logoaccess.png';
import '../../Login/styles.css';
import IconButton from '../../../components/IconButton';
import { FaExternalLinkAlt, FaLink } from 'react-icons/fa';

export default function CadastroEventoParticipanteListaConcluido({ match }) {
  const id = match.params.id;
  const [evento, setEvento] = useState({});
  const history = useHistory();

  const buscar = () => {
    api({
      method: "get",
      action: '/eventoSemLogin/' + id,
    }).then(response => {
      var dadosEvento = response.data.data;
      setEvento(dadosEvento);
    }).catch(err => {
      //console.log(err)
    });
  };//buscar

  useEffect(() => { //onload
    buscar();
  },
    // eslint-disable-next-line
    []);

  return (
    <div id="auth" style={
      (evento.cor !== undefined) ? {
        backgroundImage: "none",
        backgroundColor: evento.cor,
      } : {
        backgroundImage: "none",
        backgroundColor: "#AAAAAA",
      }
    }>
      <div className="container">
        <div className="row">
          <div className="col-md-5 col-sm-12 mx-auto">
            <div className="card pt-4">
              <div className="card-body">
                <div className="text-center mb-5">
                  {localStorage.getItem('logomarcaEvento') ?
                    <img alt="" src={localStorage.getItem('logomarcaEvento')} height="48" className='mb-4' /> :
                    <img alt="" src={logo} height="48" className='mb-4' />
                  }
                  <p>O seu cadastro no evento <strong>{evento.nome}</strong> foi realizado com sucesso!</p>
                  {((evento.linkfinalcadastro ?? '') !== '') ?
                    <>
                      <p>clique abaixo e acesse o material de apoio</p>
                      <IconButton
                        target="_blank"
                        title="Acessar Conteúdo"
                        color="primary"
                        icon={<FaExternalLinkAlt size={20} />}
                        to={{
                          pathname: evento.linkfinalcadastro,
                        }}>Acessar Conteúdo</IconButton>
                    </>
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
